import type * as React from 'react';

interface FieldBoxProps {
  label: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export function FieldBox({ icon, label, children }: FieldBoxProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-sm font-medium text-gray-400">
        {icon}
        <span>{label}</span>
      </div>
      <div className="px-4 py-3 bg-gray-50/50 rounded-xl border border-gray-200/50 text-sm font-medium text-gray-900 min-h-[46px] flex items-center">
        {children}
      </div>
    </div>
  );
}
